import { Modal, Button } from 'react-bootstrap';
import DataTable from '../../DataTable';
import { PlusCircle } from '@styled-icons/fa-solid';
import checkmark from '../../../images/checkmark.png';
import customer from '../../../images/customer.png';

const ParentsModal = ({ showModal, setShowModal, onContinue, parents, selectedParent, onParentSelect, value }) => {
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    setShowModal(false);
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered animation={false} dialogClassName="modal-50w">
      <Modal.Header className="floating-box-header-newload">Select Parent Company</Modal.Header>
      <Modal.Body>
        <div className="step-banner with-img" style={{ minHeight: '0' }}>
          <img src={customer} width="70" height="70" alt="customer" />
          <p>Please select the parent company from the list below you wish to link to this new load</p>
        </div>
        <DataTable
          dontRefreshPagination
          sortable
          filterable
          data={(parents ?? []).map((item, idx) => ({
            ...item,
            __rowKey: `${item.ParentTraderId ?? 'parent'}-${idx}`,
          }))}
          className="table-bordered"
          idKey="__rowKey"
        >
          <DataTable.Pagination itemsPerPage={[5, 10, 20]} />
          <DataTable.Headers style={{ fontSize: '11px' }} />
          <DataTable.Row
            className={(item) => {
              if (item.ParentTraderId === selectedParent) {
                return 'clientID-selected-row';
              }
              return '';
            }}
            style={{ fontSize: '16px' }}
          />
          <DataTable.Column colKey="companyName" header="Company Name" />
          <DataTable.Column colKey="eori" header="EORI" />
          <DataTable.Column header="Select" style={{ height: '1px', padding: 0 }} headerStyle={{ textAlign: 'center' }}>
            {(query) => (
              <button
                className="external-table-link"
                onClick={() => {
                  onParentSelect(query.ParentTraderId);
                }}
              >
                {query.ParentTraderId !== selectedParent ? (
                  <PlusCircle width="1.1rem" height="1.1rem" />
                ) : (
                  <img src={checkmark} width="20px" alt="check" />
                )}
              </button>
            )}
          </DataTable.Column>
        </DataTable>
      </Modal.Body>
      <Modal.Footer className="w-100 justify-content-end" style={{ flexDirection: 'row' }}>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleContinue} disabled={!selectedParent}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ParentsModal;
